import React from 'react';
import SignArea from '../components/SignArea';
import RecheckTable from '../components/RecheckTable';
import PrintButton from '../components/PrintButton';

import '../PrintFireInspection.less';

const RuralHomestay = ({ data }) => {

    const groups = {};

    (data.checklist || []).forEach(item => {
        if (!groups[item.category]) {
            groups[item.category] = [];
        }
        groups[item.category].push(item);
    });

    return (
        <div className="print-container">

            <PrintButton />

            <div className="sheet">

                <div className="record-no">
                    编号：{data.recordNo}
                </div>

                <h1 className="title">
                    朱家角镇乡村民宿消防安全一铺一档
                </h1>

                <table className="main-table">

                    <tbody>

                        <tr>
                            <td className="label">单位名称</td>
                            <td colSpan={4}>{data.companyName}</td>
                            <td className="label">联系人及电话</td>
                            <td colSpan={2}>
                                {data.contactName}
                                &nbsp;
                                {data.contactPhone}
                            </td>
                        </tr>

                        <tr>
                            <td className="label">单位地址</td>
                            <td colSpan={4}>{data.address}</td>

                            <td className="label">
                                总建筑面积（㎡）
                            </td>

                            <td colSpan={2}>
                                {data.buildingArea}
                            </td>
                        </tr>

                        <tr>
                            <td className="label">
                                房屋类型
                            </td>

                            <td colSpan={4}>
                                {data.houseType}
                            </td>

                            <td className="label">
                                使用情况
                            </td>

                            <td colSpan={2}>
                                {data.usageType}
                            </td>
                        </tr>

                        <tr>
                            <td className="label">
                                建筑结构
                            </td>

                            <td colSpan={4}>
                                {data.buildingStructure}
                            </td>

                            <td className="label">
                                产权人及电话
                            </td>

                            <td colSpan={2}>
                                {data.ownerName}
                                &nbsp;
                                {data.ownerPhone}
                            </td>
                        </tr>

                        <tr>
                            <td className="label">
                                建筑层数及房间
                            </td>

                            <td colSpan={4}>
                                共{data.floorCount}层，
                                客房数{data.roomCount}间
                            </td>

                            <td className="label">
                                所属村居
                            </td>

                            <td colSpan={2}>
                                {data.villageName}
                            </td>
                        </tr>

                        <tr className="table-header">
                            <td>项目</td>
                            <td colSpan={4}>排查事项</td>
                            <td>是</td>
                            <td>否</td>
                            <td>不涉及</td>
                        </tr>

                        {
                            Object.keys(groups).map(category => {

                                const items = groups[category];

                                return items.map((item, index) => (

                                    <tr key={item.id}>

                                        {
                                            index === 0 &&
                                            (
                                                <td
                                                    rowSpan={
                                                        items.length
                                                    }
                                                >
                                                    {category}
                                                </td>
                                            )
                                        }

                                        <td
                                            colSpan={4}
                                            className="content-cell"
                                        >
                                            {item.sortNo}、
                                            {item.itemContent}
                                        </td>

                                        <td>
                                            {
                                                item.result === 'yes'
                                                    ? '√'
                                                    : ''
                                            }
                                        </td>

                                        <td>
                                            {
                                                item.result === 'no'
                                                    ? '√'
                                                    : ''
                                            }
                                        </td>

                                        <td>
                                            {
                                                item.result === 'not_applicable'
                                                    ? '√'
                                                    : ''
                                            }
                                        </td>

                                    </tr>
                                ));
                            })
                        }

                    </tbody>

                </table>

                <SignArea
                    data={data}
                    date={data.inspectionDate}
                />

                <div className="conclusion-box">

                    <div className="title2">
                        初步结论：
                    </div>

                    <div>
                        该单位
                        {data.result === 'yes'
                            ? '☑通过'
                            : '☐通过'}

                        &nbsp;&nbsp;

                        {data.result === 'no'
                            ? '☑不通过'
                            : '☐不通过'}
                    </div>

                    <div className="notice">
                        {data.rectifyNotice}
                    </div>

                </div>

                <RecheckTable data={data} />

            </div>

        </div>
    );
};

export default RuralHomestay;